(function () {
  function setActiveCompare(section, value) {
    if (!section) return;
    const nextValue = String(value || "2");
    section.setAttribute("data-el-compare-active", nextValue);

    section.querySelectorAll("[data-el-compare-option]").forEach((option) => {
      const isActive = option.getAttribute("data-el-compare-option") === nextValue;
      option.classList.toggle("is-active", isActive);
      option.hidden = !isActive;
    });
  }

  function closeDropdown(dropdown) {
    if (!dropdown) return;
    const trigger = dropdown.querySelector("[data-el-compare-trigger]");
    const menu = dropdown.querySelector("[data-el-compare-menu]");
    dropdown.classList.remove("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "false");
    if (menu) menu.hidden = true;
  }

  function openDropdown(dropdown) {
    if (!dropdown) return;
    const trigger = dropdown.querySelector("[data-el-compare-trigger]");
    const menu = dropdown.querySelector("[data-el-compare-menu]");
    dropdown.classList.add("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    if (menu) menu.hidden = false;
  }

  function selectOption(section, dropdown, optionButton) {
    const value = optionButton.getAttribute("data-el-compare-value");
    const label = dropdown.querySelector("[data-el-compare-label]");
    const optionText = optionButton.querySelector(".el-compare-table__select-option-text");

    if (label && optionText) {
      label.innerHTML = optionText.innerHTML;
    }

    dropdown.querySelectorAll("[data-el-compare-value]").forEach((option) => {
      const isSelected = option === optionButton;
      option.classList.toggle("is-selected", isSelected);
      option.setAttribute("aria-selected", isSelected ? "true" : "false");
    });

    setActiveCompare(section, value);
    closeDropdown(dropdown);
  }

  function initCompareTable(root) {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll("[data-el-compare-table]").forEach((section) => {
      const dropdown = section.querySelector("[data-el-compare-dropdown]");
      const selected = dropdown
        ? dropdown.querySelector(".el-compare-table__select-option.is-selected")
        : null;
      const value = selected
        ? selected.getAttribute("data-el-compare-value")
        : section.getAttribute("data-el-compare-active") || "2";
      setActiveCompare(section, value);
      if (dropdown) closeDropdown(dropdown);
    });
  }

  document.addEventListener("click", (event) => {
    const trigger = event.target.closest("[data-el-compare-trigger]");
    const optionButton = event.target.closest("[data-el-compare-value]");
    const dropdown = event.target.closest("[data-el-compare-dropdown]");

    if (optionButton) {
      const section = optionButton.closest("[data-el-compare-table]");
      const parentDropdown = optionButton.closest("[data-el-compare-dropdown]");
      if (section && parentDropdown) {
        selectOption(section, parentDropdown, optionButton);
      }
      return;
    }

    if (trigger) {
      const parentDropdown = trigger.closest("[data-el-compare-dropdown]");
      if (!parentDropdown) return;
      const isOpen = parentDropdown.classList.contains("is-open");
      document.querySelectorAll("[data-el-compare-dropdown].is-open").forEach(closeDropdown);
      if (!isOpen) openDropdown(parentDropdown);
      return;
    }

    if (!dropdown) {
      document.querySelectorAll("[data-el-compare-dropdown].is-open").forEach(closeDropdown);
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-el-compare-dropdown].is-open").forEach(closeDropdown);
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initCompareTable());
  } else {
    initCompareTable();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initCompareTable(event.target);
  });
})();
